export default __webpack_public_path__ + "static/media/img-ltsh-3-ovato-nation.7de61a10.png";